import {Formik, FormikErrors} from 'formik';
import * as React from 'react';
import {useCallback, useState} from 'react';
import {useAppTranslation} from '../../services/i18n';
import {useAppDispatch} from '../../store';
import {createCatalogueCategory} from '../../store/catalogues';
import {Button, LinearProgress} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Paper from '@mui/material/Paper';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {isApiResultError} from '../../helpers/api';
import {QuestionCatalogueCategoryCreate} from "generated-api";
import {CategoryFormFields} from "components/catalogue/CategoryEditForm";

type Props = {
    catalogueId: number;
    onSuccess: (result: any) => unknown;
    onClose: () => unknown;
};

export const CategoryAddForm = (props: Props) => {
    const t = useAppTranslation();
    const dispatch = useAppDispatch();
    const [isSaving, setIsSaving] = useState(false);

    const {catalogueId, onSuccess, onClose,} = props;

    const handleSaveItem = useCallback(
        async (values: QuestionCatalogueCategoryCreate) => {
            setIsSaving(true);
            const result = await dispatch(createCatalogueCategory({
                questionCatalogueId: catalogueId,
                body: values
            }));
            setIsSaving(false);

            if (!isApiResultError(result)) {
                onSuccess(result.payload);
                onClose();
            }
        }, [catalogueId, dispatch, onSuccess, onClose]);

    const handleValidate = useCallback((values: QuestionCatalogueCategoryCreate) => {
        let errors = {} as FormikErrors<QuestionCatalogueCategoryCreate>;
        if (!values.title) {
            errors.title = t('catalogues.categories.form.error.titleRequired');
        }
        return errors;
    }, [t]);

    return (
        <Dialog open={true} onClose={props.onClose} PaperComponent={Paper}>
            <Formik
                initialValues={{title: ''} as QuestionCatalogueCategoryCreate}
                onSubmit={handleSaveItem}
                validate={handleValidate}
            >
                {(props) => (
                    <form onSubmit={props.handleSubmit}>
                        <DialogTitle>
                            {t('catalogues.categories.add')}
                        </DialogTitle>
                        <LinearProgress hidden={!isSaving}/>
                        <DialogContent>
                            <CategoryFormFields/>
                        </DialogContent>
                        <DialogActions>
                            <Button color={'inherit'} onClick={onClose} disabled={isSaving}>
                                {t('form.cancel')}
                            </Button>
                            <Button color={'primary'} variant={'contained'} type={'submit'} disabled={isSaving}>
                                {t('form.add')}
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
};
